import React from 'react';
import { Button } from './ui/button';
import { CheckCircle2 } from 'lucide-react';

const ImpactSection = () => {
  return (
    <section className="pt-5 pb-5 bg-gradient-to-br from-neo-emerald to-[#1db868] text-neo-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-neo-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-neo-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-4xl mx-auto px-4 py-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6">
          Ready to Transform Your Farm Into a Climate Solution?
        </h2>
        <p className="text-xl mb-8 text-neo-white/90 font-body">
          Join the sustainable agriculture revolution today and start making a positive climate impact while increasing your income
        </p>
        
        <Button 
          size="lg"
          className="bg-neo-white text-neo-emerald hover:bg-neo-green-tint px-10 py-7 text-lg font-heading font-semibold h-auto shadow-xl hover:shadow-2xl transition-all glow-emerald-hover"
        >
          Start Your Climate Journey
        </Button>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-8 text-neo-white/90 font-body">
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5" />
            <span>No setup fees</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5" />
            <span>Free consultation</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5" />
            <span>Climate impact guaranteed</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
